export const showGridSize = [
  {
    length: "Довжина стопи(см)",
    sizeEU: "Розмір EU",
    sizeUS: "Розмір US",
    sizeUK: "Розмір UK",
  },
  {
    length: "25,1",
    sizeEU: "39",
    sizeUS: "7",
    sizeUK: "5",
  },
  {
    length: "25,4",
    sizeEU: "40",
    sizeUS: "7,6",
    sizeUK: "6",
  },
  {
    length: "25,8",
    sizeEU: "40,5",
    sizeUS: "8",
    sizeUK: "6,5",
  },
  {
    length: "26,3",
    sizeEU: "41",
    sizeUS: "8,5",
    sizeUK: "7",
  },
];
